export default __webpack_public_path__ + "static/media/c_5.c846b139.jpg";